module.exports = __webpack_public_path__ + "static/media/logo-air.ab01d18c.png";